
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 9 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M5.683 5.09a2.326 2.326 0 01-2.967 0L.6 15.625l3.6 3.75 3.6-3.75L5.683 5.09z"}}),_c('path',{attrs:{"d":"M4.2.625c1.326 0 2.4 1.12 2.4 2.5s-1.074 2.5-2.4 2.5c-1.326 0-2.4-1.12-2.4-2.5s1.074-2.5 2.4-2.5z"}})])])
          )
        }
      }
    